import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { VisitorTracker } from "./VisitorTracker";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const Layout = ({ children }) => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const timer = window.setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return (
    <div className="min-h-screen bg-[#F8F6F2]">
      <VisitorTracker />
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
};
